import { render, staticRenderFns } from "./window-tertiary.vue?vue&type=template&id=5e0631c7&scoped=true&"
import script from "./window-tertiary.vue?vue&type=script&lang=js&"
export * from "./window-tertiary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e0631c7",
  null
  
)

export default component.exports